import type { GiftWithCardOption, RecipientGift, RedemptionCard } from '@consumer/types/serializers'
import type CardManagementOrder from '@corp/types/serializers/CardManagementOrder'

type CardSessionInfo = {
  token?: Ref<string | undefined>
  card: Ref<RedemptionCard | undefined | null>
  cardOptions?: Ref<GiftWithCardOption[] | undefined>
  gift?: RecipientGift,
  corporateOrder?: CardManagementOrder | null
}

const CARD_SESSION_STORAGE_KEY = 'redemption_card_session_info'

export function useCardSession (config?: CardSessionInfo) {
  if (config) {
    provide(CARD_SESSION_STORAGE_KEY, config)
  }

  return inject(CARD_SESSION_STORAGE_KEY) as CardSessionInfo
}
